import React from 'react'
import logo from '../images/companyLogo192.png'
const Footer = () => {


    return (
        <footer className=" text-[#021763] mt-auto fixed bottom-0 left-0 right-0 bg-white  px-4 max-[350px]:px-1 text-cente text-center border-t-[1px] border-t-gray-300 font-QLight py-2 ">
            <div className='grid grid-cols-7 items-center'>
                <div className='col-span-3 flex justify-start '>

                    <p className="text-sm    max-[500px]:text-[12px] max-[400px]:text-[11px] ">&copy; {new Date().getFullYear()}.</p>
                    <p className="text-sm    max-[500px]:text-[12px] max-[400px]:text-[11px] "> All rights reserved.</p>
                </div>
                <img className='w-[50px] object-contain max-[400px]:w-[40px] max-[350px]:w-[30px] max-[330px]:w-[22px] mx-auto h-full col-span-1' src={logo} alt="" />
                <div className='flex justify-end col-span-3  '>

                    <p className="text-sm max-[500px]:text-[12px]  max-[400px]:text-[11px] mr-[5px] ">Powered by </p>
                    <a href={process.env.REACT_APP_DART_POS_URL} className="text-sm max-[500px]:text-[12px] text-gray-500 max-[400px]:text-[11px] cursor-pointer ">Dartpos</a>
                </div>
            </div>

        </footer>

    )
}

export default Footer